// https://developers.cloudflare.com/rules/transform/request-header-modification/reference/header-format/
const validValueCharacters = [
	'_',
	':',
	';',
	'.',
	',',
	'\\',
	'/',
	'"',
	"'",
	'?',
	'!',
	'(',
	')',
	'{',
	'}',
	'[',
	']',
	'@',
	'<',
	'>',
	'=',
	'-',
	'+',
	'*',
	'#',
	'$',
	'&',
	'`',
	'|',
	'~',
	'^',
	'%',
	' ',
];

const replaceEncodedHeaderValueChars = validValueCharacters.map((char) => ({
	encodedChar: encodeURIComponent(char),
	char,
}));

function encodeHeaderValue(string: string) {
	let encodedString = encodeURIComponent(string);

	replaceEncodedHeaderValueChars.forEach(({ char, encodedChar }) => {
		encodedString = encodedString.replaceAll(encodedChar, char);
	});

	return encodedString;
}

export function encodeHeaders(headers: Record<string, string>) {
	return Object.entries(headers).reduce<Record<string, string>>((acc, [key, value]) => {
		acc[encodeURIComponent(key)] = encodeHeaderValue(value);
		return acc;
	}, {});
}
